import { buildQmsOnlyOfficeDocumentUrl } from "./qmsDocumentDownloadUtils";

/** Public document API — OnlyOffice callback must be reachable from Document Server. */
export const QMS_ONLYOFFICE_DOCUMENT_API =
  "https://ascensionqapi.azurewebsites.net/aqdocumentapi/api/";

export const QMS_ONLYOFFICE_SERVER_URL =
  "https://documentserver.ukwest.cloudapp.azure.com";

/** Read-only preview — aligned with working eISF embed customization. */
export const QMS_ONLYOFFICE_VIEW_CUSTOMIZATION = {
  autosave: false,
  forcesave: false,
  commentAuthorOnly: false,
  comments: false,
  compactHeader: true,
  compactToolbar: true,
  hideRightMenu: true,
  hideLeftMenu: true,
  integrationMode: "embed",
  macros: false,
  macrosMode: "warn",
  plugins: false,
  showReviewChanges: false,
  spellcheck: false,
  toolbarHideFileName: false,
  toolbarNoTabs: false,
  unit: "cm",
  zoom: 100,
  chat: false,
  about: false,
  hideTopBar: true,
  leftMenu: false,
  help: false,
  feedback: false,
};

export function buildQmsOnlyOfficeViewConfig({
  extension,
  fileTitle,
  documentUrl,
  documentKeyPrefix = "qms_preview",
}) {
  const normalizedExtension = String(extension || "")
    .trim()
    .replace(/^\./, "")
    .toLowerCase();

  const { url: viewerUrl, blobUrl, source, error } =
    buildQmsOnlyOfficeDocumentUrl(documentUrl);

  if (error) {
    console.error("[QMS preview] Invalid document URL for OnlyOffice:", {
      rawDocumentUrl: documentUrl,
      blobUrl,
      source,
      error,
    });
  } else if (process.env.NODE_ENV !== "production") {
    console.info("[QMS preview] OnlyOffice fetch URL:", {
      onlyOfficeUrl: viewerUrl,
      blobUrl,
      source,
    });
  }

  const fetchUrl = viewerUrl || blobUrl;
  const callbackOriginalUrl = blobUrl || fetchUrl;

  return {
    document: {
      fileType: normalizedExtension || inferFileTypeFromTitle(fileTitle),
      key: `key_${documentKeyPrefix}_${Date.now()}`,
      title: fileTitle,
      url: fetchUrl,
      permissions: {
        edit: false,
        download: true,
        print: true,
        review: false,
        comment: false,
        chat: false,
      },
    },
    documentType: getDocumentType(normalizedExtension, fileTitle),
    editorConfig: {
      mode: "read",
      customData: fetchUrl,
      lang: "en",
      callbackUrl: `${QMS_ONLYOFFICE_DOCUMENT_API}onlyoffice/save?originalUrl=${encodeURIComponent(
        callbackOriginalUrl,
      )}`,
      autosave: true,
      forcesave: true,
      user: { id: "viewer", name: "Viewer" },
      customization: {
        ...QMS_ONLYOFFICE_VIEW_CUSTOMIZATION,
      },
    },
    width: "100%",
    height: "100%",
  };
}

function inferFileTypeFromTitle(fileTitle) {
  const clean = String(fileTitle || "").split("?")[0];
  const parts = clean.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "pdf";
}

function getDocumentType(ext, fileTitle) {
  const fromExt = ext || inferFileTypeFromTitle(fileTitle);
  if (fromExt === "doc" || fromExt === "docx") return "word";
  if (fromExt === "xls" || fromExt === "xlsx" || fromExt === "csv") return "cell";
  if (fromExt === "ppt" || fromExt === "pptx") return "slide";
  if (fromExt === "pdf") return "pdf";
  return "word";
}
